import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import 'components/desktop/_general/MainNavigationLeft/MainNavigationLeft.scss';
import { getBreadCrumbs } from 'components/desktop/_general/MainNavigationLeft/MainNavigationLeftHandlers';
import SIDEBAR_ITEMS from 'components/desktop/_general/MainNavigationLeft/constants/SidebarItems';
import { usePathname } from 'components/desktop/_general/MainNavigationLeft/hooks/usePathname';
import NavigationLanguageSwitch from 'components/desktop/_general/NavigationLanguage/NavigationLanguageSwitch';
import UserAvatar from 'components/desktop/_general/UserAvatar/UserAvatar';
import { getPicturePath } from 'functions/getPicturePath';
import { RootState } from 'reducers/rootReducer';
import { UserCornerInfo } from 'types/User/UserCornerInfo/UserCornerInfo';

import MainNavigationLeft from '../MainNavigationLeft/MainNavigationLeft';

const MainNavigationTop = (): JSX.Element => {
	const reduxUser: UserCornerInfo = useSelector((state: RootState) => state.user);
	const reduxAllowedUiLanguages: string[] = useSelector(
		(state: RootState) => state.allowedUiLanguages
	);
	const pathname: string = usePathname();
	const { t } = useTranslation();
	const [logoPath, setLogoPath] = useState<string>('/img/logo/logo_sm.png');

	return (
		<div style={mainStyle}>
				<MainNavigationLeft />
		</div>
	);
};

export default MainNavigationTop;

const mainStyle: React.CSSProperties = {
	color: '#6066c1',
	padding: '0.4rem',
	borderBottom: '1px solid #dddfff',
	backgroundImage: 'linear-gradient(180deg, #f4f5ff, white)',
	position: 'sticky',
	top: 0,
	zIndex: 100, // Optional: ensures it stays above other content
};
